import { render, staticRenderFns } from "./topupOrderDetail.vue?vue&type=template&id=ba6afacc&scoped=true"
import script from "./topupOrderDetail.vue?vue&type=script&lang=ts"
export * from "./topupOrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./topupOrderDetail.vue?vue&type=style&index=0&id=ba6afacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6afacc",
  null
  
)

export default component.exports